import React from "react";
import { MdCheck } from "react-icons/md";

const PermissionItem = ({ name, actions, onActionChange, roleState }) => {
  return (
    <div className="flex justify-between items-center p-4 bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
      <h3 className="text-lg font-semibold text-gray-700">{name}</h3>

      <div className="flex space-x-6">
        {["read", "write", "delete"].map((action) => (
          <label
            key={action}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <input
              type="checkbox"
              className="hidden peer"
              checked={roleState[name]?.[action] || false}
              onChange={() => onActionChange(name, action)}
            />
            <div className="w-5 h-5 border border-gray-300 rounded-md flex items-center justify-center bg-white peer-checked:bg-brand-500 transition duration-200">
              {actions.includes(action) && (
                <MdCheck className="text-white w-5 h-5" />
              )}
            </div>
            <span className="capitalize text-gray-600 hover:text-indigo-500">
              {action}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default PermissionItem;
